import { Breadcrumb, Icon, Tooltip } from "antd";
import React, { useEffect, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import uid from 'uid';
import styled from "styled-components";

import { checkForPermissions } from "../UI/Layout/utils";
import { useTopBar } from '~/context/TopBarContext';

export var ModuleHeaderWrapper = styled.div`
    display: none;
`;

export var ButtonsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export var HeaderLeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  white-space: nowrap;

  > input {
    max-width: 300px;
  }
`;

export var HeaderRightContent = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  white-space: nowrap;

  > .ant-calendar-picker{
    min-width: 170px;
  }
`;

export var HeaderBody = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
`;

export var HeaderCenterContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export var ModuleHeader = function(props) {
  var breadcrumbs = props.breadcrumbs;
  var title = props.title || null;

  var history = useHistory();
  var reduxState = useSelector(function(state) {
    return {
      user: state.user,
      users: state.users,
    };
  });

  var user = reduxState.user;
  var users = reduxState.users;
  var topBar = useTopBar();

  var isPartner = user.permissions_group_name === "Sócio";
  var activeUsers = users.filter(function(u) { return !u.deleted_at && !u.disabled_at; });

  var allowedUsersName =
    isPartner && activeUsers.length > 0
      ? activeUsers
          .filter(function(u) { return checkForPermissions(u.permissions) && !!u.name; })
          .map(function(u) { return u.name; })
          .join(", ")
      : "";

  var handleInicioClick = function() {
    history.push('/');
  };

  // Find search onChange handler from props.search or from center children
  var findSearchHandler = function() {
    // Check props.search first
    if (props.search && props.search.props && props.search.props.onChange) {
      return props.search.props.onChange;
    }
    // Check center children for Input with search placeholder
    if (props.center && props.center.props && props.center.props.children) {
      var children = Array.isArray(props.center.props.children)
        ? props.center.props.children
        : [props.center.props.children];
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child && child.props && child.props.prefix && child.props.onChange) {
          return child.props.onChange;
        }
        if (child && child.props && child.props.placeholder && child.props.onChange && (
          child.props.placeholder === 'Pesquisar' ||
          child.props.placeholder === 'Pesquisar...' ||
          child.props.placeholder === 'Buscar...' ||
          child.props.placeholder === 'Buscar'
        )) {
          return child.props.onChange;
        }
      }
    }
    return null;
  };

  var searchHandler = findSearchHandler();
  var hasSearch = !!searchHandler;

  // Register the search handler in context so TopBar can call it directly
  useEffect(function() {
    if (topBar && topBar.setPageSearchHandler) {
      topBar.setPageSearchHandler(searchHandler);
    }
    return function() {
      if (topBar && topBar.setPageSearchHandler) {
        topBar.setPageSearchHandler(null);
      }
    };
  }, [searchHandler]);

  // Push content to TopBar context — use useLayoutEffect for synchronous cleanup
  useLayoutEffect(function() {
    if (topBar && topBar.setHeaderContent) {
      topBar.setHeaderContent({
        breadcrumbs: breadcrumbs,
        title: title,
        hasSearch: hasSearch,
        center: props.center,
        actions: props.actions,
        advanced: props.advanced,
        isPartner: isPartner,
        allowedUsersName: allowedUsersName,
        handleInicioClick: handleInicioClick,
      });
    }

    return function() {
      if (topBar && topBar.setHeaderContent) {
        topBar.setHeaderContent(null);
        topBar.setPageSearchTerm('');
      }
    };
  }, [breadcrumbs, title, props.search, props.center, props.actions, props.advanced]);

  // Render nothing inline - content goes to TopBar
  return null;
};
